import { useMotionValue } from 'framer-motion';
import { useCallback } from 'react';

export default () => {
  const x = useMotionValue(0);
  const y = useMotionValue(0);

  const onMouseMove = useCallback(
    event => {
      x.set(event.clientX - event.target.getBoundingClientRect().left);
      y.set(event.clientY - event.target.getBoundingClientRect().top);
    },
    [x, y]
  );

  return { onMouseMove, x, y };
};
